import React, { useState, useEffect } from "react";
import { Page, Document, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function AllPages(props) {
  const [numPages, setNumPages] = useState(null);
  const [pdfBlob, setPdfBlob] = useState(null);

  const { pdf } = props;

  useEffect(() => {
    const fetchPdf = async () => {
      const token = localStorage.getItem('token')
      const res = await fetch(pdf, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      const blob = await res.blob()
      const url = URL.createObjectURL(blob)
      setPdfBlob(url)
    }

    if (pdf) fetchPdf()

    // cleanup biar nggak memory leak
    return () => {
      if (pdfBlob) URL.revokeObjectURL(pdfBlob)
    }
  }, [pdf])

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  if (!pdfBlob) return <div>Loading PDF...</div>

  return (
    <Document
      file={pdfBlob}
      onLoadSuccess={onDocumentLoadSuccess}
    >
      {Array.from(new Array(numPages), (el, index) => (
        <Page key={`page_${index + 1}`} pageNumber={index + 1} />
      ))}
    </Document>
  );
}